import * as yup from 'yup';
import { VALIDATION_ERROR } from 'utils/enums';

export const phoneValidationSchema = yup.string().matches(/^380\d{9}$/, 'Неправильний формат');
export const radankPhoneValidationSchema = yup
	.string()
	.matches(/^0\d{9}$/, 'Неправильний формат')
	.required(VALIDATION_ERROR.REQUIRED);
